// @flow
import React, { Component, Fragment } from 'react';
import { CommaFormat } from '../../../../elements/Price/Price';   

import style from './StatisticCard.scss';
 
type Props = {  
};

type State = {  
};

const BASE_DAY = new Date('09/02/2021');

function calcDaysBetween(d1: Date, d2: Date) {
  return Math.floor((d1.getTime() - d2.getTime()) / (1000 * 3600 * 24));
};

const dataStatistics = [
  {
    value: 323106 + calcDaysBetween(new Date(), BASE_DAY) * 13,
    label: 'Productos entregados'
  },
  {
    value: 171182 + calcDaysBetween(new Date(), BASE_DAY) * 8,
    label: 'Clientes satisfechos'
  },
  {
    value: 5261742 + calcDaysBetween(new Date(), BASE_DAY) * 834,
    label: 'Dólares Ahorrados'
  }
];

export default class StatisticCard extends Component<Props, State> {

  constructor(props: Props) {
  super(props);

  this.state = { 
  };
  } 

  render() {  

  return (  
    <section className={style.root}>
      <div className={style.cardStatisticsWrap}>
      {dataStatistics.map((item, index: number)=> (
        <Fragment key={`card-statistic-${index}`}>
          <div  className={style.cardStatisticsContent}>
            <div className={style.dataWrap}>
              <h4><CommaFormat price={item.value} decimalScale={0} /></h4>
              <span> {item.label} </span>
            </div>
            
          </div>
          { dataStatistics.length - 1 > index && <div  className={style.verticalLine}/>}
        </Fragment>
        
      ))}
    </div>
    </section>
  );
  }
}


StatisticCard.propTypes = { 
};
 



// WEBPACK FOOTER //
// ./src/modules/home/elements/StatisticCard/StatisticCard.jsx